<!--  -->
<template>
  <div class="allbox">
    <div class="line" />
    <div class="keyindicators">
      <div class="ketitembox">
        <div
          style="margin-right: 15px;display: flex;flex-direction: column;"
        >
          <span class="addtext">昨日新增粉丝数</span>
          <span class="addnum">{{ keyindicatorsyesterday.yesterday_follow_fans }}</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <span class="addtext">今日新增粉丝数</span>
          <span class="addnum">{{ today.today_follow_fans }}</span>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <span class="addtext">昨日取关注人数</span>
          <span class="addnum">{{ keyindicatorsyesterday.yesterday_cancel_fans }}</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <span class="addtext">今日取关注人数</span>
          <span class="addnum">{{ today.today_cancel_fans }}</span>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <div class="addtext">昨日净增</div>
          <div class="addnum">{{ net_growth.yesterday_net_growth }}</div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">今日净增</div>
          <div class="addnum">{{ net_growth.today_net_growth }}</div>
        </div>
      </div>
      <div class="ketitembox">
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">累计关注</div>
          <div class="addnum">{{ totalAll }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="line-linr" /> -->
    <div class="item">
      <el-date-picker
        v-model="date"
        style="margin: 0 15px;"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :clearable="false"
      />
      <!-- v-show="statistics_date.length>0" -->
      <el-button type="primary" class="item_button" @click="theUpdata">更新</el-button>
    </div>
    <div class="container">
      <div id="main" class="echarts" style="width:90vw;" />
    </div>
    <el-table
      :data="alllist"
      border
      style="width: 80%;margin:0 auto"
    >
      <el-table-column
        prop="day"
        label="时间"
        width="400"
        align="center"
      />
      <el-table-column
        prop="follow_fans"
        label="新增粉丝数"
        width="400"
        align="center"
      />
      <el-table-column
        prop="cancel_fans"
        label="取关粉丝数"
        width="400"
        align="center"
      />
      <el-table-column
        prop="net_growth"
        label="净增数"
        align="center"
      />
    </el-table>
  </div>
</template>

<script>
import { totalStatistics, spCorpchart } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      keyindicatorsyesterday: {},
      net_growth: {},
      today: {},
      totalAll: null,
      date: [],
      list: [],
      add_user: [],
      del_user: [],
      reply_percentage: [],
      statistics_date: [],
      // pickerOptions: {
      //   disabledDate(time) {
      //     const curDate = new Date().getTime()
      //     const three = 180 * 24 * 3600 * 1000
      //     const threeMonths = curDate - three
      //     // var thatDay = time.getTime()
      //     return (
      //       time.getTime() > Date.now() - 8.64e6 ||
      // 			time.getTime() < threeMonths
      //     )
      //   }
      // },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (time.getTime() > Date.now()) {
            return true
          }
          if (this.selectDate !== '') {
            const one = 31 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      employee_no: null,
      alllist: []
    }
  },
  created() {
    this.employee_no = this.$route.query.employee_no
    this.datafliter()
    this.updatalist()
    // console.log('粉丝', this.$route.query.employee_no)
  },
  mounted() {
    this.fanslistr()
  },
  methods: {
    async fanslistr() {
      const data = await totalStatistics({ employee_no: this.employee_no })
      this.keyindicatorsyesterday = data.data.yesterday
      this.net_growth = data.data.net_growth
      this.today = data.data.today
      this.totalAll = data.data.totalAll
      console.log('keyindicatorsyesterday', this.keyindicatorsyesterday)
      console.log('data', data)
    },
    echartsdemo() {
      var chartDom = document.getElementById('main')
      var myChart = this.$echarts.init(chartDom)
      var option
      option = {
        legend: {
          // data: ['新增粉丝数', '取消粉丝数', '净增数'],
          top: '3%'
        },
        xAxis: {
          type: 'category',
          data: this.statistics_date
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '新增粉丝数',
            type: 'line',
            data: this.del_user
          },
          {
            name: '取关粉丝数',
            data: this.add_user,
            type: 'line'
          },
          {
            name: '净增数',
            type: 'line',
            data: this.reply_percentage
          }
        ],
        tooltip: {
          trigger: 'axis', // 悬停在坐标轴上时触发 tooltip
          axisPointer: {
            type: 'line' // 设置指示器类型为线形
          }
        }
      }
      option && myChart.setOption(option)
      this.$nextTick(() => {
        window.addEventListener('resize', function() {
          myChart.resize()
        })
      })
    },
    theUpdata() {
      this.updatalist()
    },
    // 时间转化
    formatDate(date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    datafliter() {
      // 默认当前日期8天前，最后日期昨天
      const today = new Date()
      const firstDate = new Date(today)
      firstDate.setDate(today.getDate() - 7)
      const secondDate = new Date(today)
      // secondDate.setDate(today.getDate() - 1)
      secondDate.setDate(today.getDate())
      const firstDateString = this.formatDate(firstDate)
      const secondDateString = this.formatDate(secondDate)
      this.date = [firstDateString, secondDateString]
      console.log('this.date[1]', this.date)
    },
    async updatalist() {
      // this.datafliter()
      console.log('this.date[0]', this.date)
      if (this.date === null) {
        this.$message.error('请选择日期')
        return
      }
      const data = await spCorpchart({ employee_no: this.employee_no, begin_time: this.date[0], end_time: this.date[1] })
      this.statistics_date = []
      this.statistics_date = data.data.cancel_fans.map((item) => {
        return item.day
      })
      this.add_user = []
      this.add_user = data.data.cancel_fans.map((item) => {
        return item.count
      })
      this.del_user = []
      this.del_user = data.data.follow_fans.map((item) => {
        return item.count
      })
      this.reply_percentage = []
      this.reply_percentage = data.data.net_growth.map((item) => {
        return item.count
      })
      this.alllist = []
      data.data.cancel_fans.forEach((item, index) => {
        this.alllist.push({
          day: data.data.cancel_fans[index].day,
          cancel_fans: data.data.cancel_fans[index].count,
          follow_fans: data.data.follow_fans[index].count,
          net_growth: data.data.net_growth[index].count
        })
      })
      this.alllist.reverse()
      console.log('alllist', this.alllist)
      this.echartsdemo()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox{
  /* padding: 30px; */
}
.line{
  width: 100%;
  height: 1px;
  background: #ccc;
}
.keyindicators{
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  box-sizing: border-box;
}
.ketitembox{
  text-align: center;
  position: relative;
  display: flex;
  width: 25%;
  justify-content: center;
}
.ketitembox::after{
  content: '';
  height: 40px;
  width: 2px;
  background: rgb(35, 139, 224);
  position: absolute;
  right: 0px;
  top: 10px;
}
.ketitembox:last-child::after{
  content: '';
  height: 0px;
  width: 0px;
}
.addtext{
  color: black;
  /* font-weight: bold; */
  font-size: 13px;
}
.addnum{
  color: red;
  font-size: 30px;
  margin-top: 15px;
}
.line-linr{
  height: 20px;
  width: 100%;
  background: #ccc;
  margin-top: 20px;
}
#main {
  /* width: 100%; */
  /* height: 650px; */
}

/* @media screen and (max-width: 768px) {
  #chart-container {
    height: 300px;
  }
} */
.echarts {
  width: 90vw;
  height: 600px;
  margin-top: 30px;
}
.item{
  margin-left: 170px;
  margin-top: 30px;
}
</style>
